angular.module('ihestiaGrid')
  .controller('ihestiaGridFixedHeaderCtrl', ['$scope',
    function($scope) {
      $scope.fixedHeaderData = {
        onlyHeader: true
      };
    }
  ]);